import { Component, Input } from '@angular/core';
import { ErrorsModel } from '@core/models';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
})
export class ErrorsComponent {
  formattedErrors: Array<string> = [];

  @Input()
  set errors(errorList: ErrorsModel) {
    this.formattedErrors = Object.keys(errorList.errors || {}).map(
      (key) => `${key} ${errorList.errors[key]}`
    );
  }

  get errorList() {
    return this.formattedErrors;
  }
}
